<template>
  <b-card no-body>
    <b-card-header>
      <!-- title and legend -->
      <div>
      <b-card-title class="mb-1 font-weight-bolder">
        Net Staking
      </b-card-title>
      <b-card-sub-title>Delegations/Undelegations over time</b-card-sub-title>
      </div>
      <!--/ title and legend -->
    </b-card-header>

    <b-card-body>
      <vue-apex-charts
        v-if="loaded"
        type="line"
        height="300"
        :options="apexChartData.netStaking.chartOptions"
        :series="apexChartData.netStaking.series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BCardSubTitle, BCardTitle,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import apexChartData from './apexChartData'
import axios from 'axios'

export default {
  components: {
    VueApexCharts,
    BCard,
    BCardHeader,
    BCardBody,
    BCardSubTitle,
    BCardTitle,
  },
  data() {
    return {
      apexChartData,
      loaded: false,
    }
  },
  mounted () {
    this.loaded = false;
    const endpoint = 'https://node-api.flipsidecrypto.com/api/v2/queries/e5948037-6ff7-4547-b9e6-1bb72dffb8fc/data/latest'
    axios.get(endpoint)
    .then(response => {
      for (let datapoint in response.data){
        var x = new Date(response.data[datapoint].DATE)
        var y = response.data[datapoint].TOTAL_DELEGATIONS
        var y2 = response.data[datapoint].TOTAL_UNDELEGATIONS
        apexChartData.netStaking.series[0].data.push({
          x: x,
          y: y
        })
        apexChartData.netStaking.series[1].data.push({
          x: x,
          y: y2
        })
      }
      this.loaded = true;
    })
    .catch(e => {
      console.error(e)
    })
  }
}
</script>
